import { FormattedMessage } from 'components/shared/Intl';
import { useUnderlyingContext } from 'hooks/useUnderlyingContext';
import type { UnderlyingCodeType } from 'models/underlying/base';
import type { CreditUnderlying } from 'models/underlying/credit';
import { FC } from 'react';

import { ActionCell, CodeCell } from '../../Common/Cells';
import { HeaderCell } from '../../Common/HeaderCell';
import { Row } from '../../Common/Row';
import { Table } from '../../Common/Table';
import { CreditDataTable } from './CreditDataTable';
export interface CreditTableProps {
  underlyings: CreditUnderlying[];
}

export const CreditTable: FC<CreditTableProps> = ({ underlyings }) => {
  const codeType: UnderlyingCodeType = 'CurveName';
  const { canBeRemoved, isReadOnly } = useUnderlyingContext();
  return (
    <Table>
      <thead>
        <tr>
          <CodeCell.Header type={codeType} />
          <HeaderCell data-column="name">
            <FormattedMessage id="name" />
          </HeaderCell>
          <ActionCell.RemoveAll />
        </tr>
      </thead>
      <tbody>
        {underlyings.map(underlying => (
          <Row key={underlying.id}>
            <CreditDataTable underlying={underlying} />
            <td className="align-middle p-2">{underlying.name}</td>
            {canBeRemoved && !isReadOnly && <ActionCell.Remove underlyingId={underlying.id} />}
          </Row>
        ))}
      </tbody>
    </Table>
  );
};

CreditTable.displayName = 'CreditTable';
